import { Handle } from 'rc-slider';
import React from 'react';

import Popover from '../Popover';

const BasicHandle = ({ forwardedRef, shouldPop, ...restProps }) => {
  delete restProps.dragging;
  return (
    <Handle ref={forwardedRef} {...restProps}>
      <Popover
        shouldPop={shouldPop}
        tip={
          <>
            <p>
              <strong>Need more?</strong>
            </p>
            <p>
              <a href="/contact-us-form/">Contact us</a> for a custom plan. Or,
              switch to Advanced for higher volumes and additional features like
              Automation.
            </p>
          </>
        }
      />
    </Handle>
  );
};

export default BasicHandle;
